<!--
  2026-09-15
  改动点：短剧会员套餐由独立卡片改为权益对比表
  说明：权益单元格为示意文案，后续按实际内容替换；开通/定制按钮沿用页面原订阅逻辑
  2026-09-15
  改动点：表头左右上圆角；套餐列 hover 浮起；第一列会员权益子列增加竖向分割线
  2026-09-15
  改动点：表头与选中列每个单元格改为上到下黄色渐变，不再使用整列一条渐变
  2026-09-15
  改动点：选中列单元格黄色调浅；会员权益右侧子列文字居中
  2026-09-15
  改动点：按短剧会员对照表填充权益文案；保留定制会员列
  2026-09-15
  改动点：选中列表头浮起改为 transform，避免切换列时表格上下抖动
  2026-09-15
  改动点：按对照表补全版权保障、特殊授权与底部备注行
  2026-09-15
  改动点：表格左右加边框；左侧分组列加粗加大；单元格内边距加倍
  2026-09-15
  改动点：选中表头改为向上延伸色块，避免上浮后与首行出现空白缝
  2026-09-16
  改动点：左右边框改到圆角单元格上，避免容器直角边框穿出圆角
  2026-09-16
  改动点：边框色统一为 #e8ddd3；每个单元格显示横竖分割线
  2026-09-16
  改动点：对号绿色加大、叉号红色加大
  2026-09-16
  改动点：特殊授权行名左对齐；底部备注左对齐
  2026-09-16
  改动点：行名与授权期限等子描述改为问号 tooltip
  2026-09-16
  改动点：表头高度与个人/企业表一致；滚动时表头与价格行吸顶
  2026-09-16
  改动点：最右侧增加定制会员占位列；价格格交互与企业定制列一致
-->
<template>
  <div
    class="compare-table aishort-table"
    :style="tableStyle"
    @mouseleave="clearHover"
  >
    <div class="head label-head" @mouseenter="clearHover">短剧会员</div>
    <div
      v-for="(item, index) in saleList"
      :key="`aishort-head-${item.goods_id || index}`"
      class="head pkg-head"
      :class="{ highlight: isHighlight(item), 'is-last': index === saleList.length - 1 }"
      @mouseenter="setHover(item)"
    >{{ item.name }}</div>

    <template v-for="row in flatRows">
      <div
        v-if="row.showGutter"
        :key="`aishort-gutter-${row.rowKey}`"
        class="gutter"
        :style="{ gridRow: `span ${row.groupSpan}` }"
      >{{ row.groupName }}</div>
      <div
        :key="`aishort-label-${row.rowKey}`"
        class="feat-cell label-cell"
        :class="{ 'price-cell': row.isPrice, 'price-label': row.spanPriceLabel, 'is-left': isLeftLabelGroup(row) }"
        :style="row.spanPriceLabel ? { gridColumn: '1 / 3' } : null"
      >
        <span class="label-text">
          {{ row.label }}
          <el-tooltip
            v-if="row.desc"
            :content="row.desc"
            placement="top"
            effect="dark"
            popper-class="pkg-help-tooltip"
          >
            <i class="el-icon-question help-icon" @click.stop></i>
          </el-tooltip>
        </span>
      </div>
      <div
        v-for="(item, pIdx) in saleList"
        :key="`aishort-cell-${row.rowKey}-${item.goods_id || pIdx}`"
        class="feat-cell pkg-cell"
        :class="{ 'price-cell': row.isPrice, highlight: isHighlight(item), 'is-last': pIdx === saleList.length - 1 }"
        @mouseenter="setHover(item)"
      >
        <template v-if="row.isPrice">
          <template v-if="isCustomPackage(item)">
            <div class="current-price is-contact">联系客服</div>
            <span class="cta-btn" @click="onSubscribe(item)">立即咨询</span>
          </template>
          <template v-else>
            <div class="current-price">
              <i>¥</i>{{ displayPrice(item) }}<span v-if="priceUnit(item)">{{ priceUnit(item) }}</span>
            </div>
            <span
              class="cta-btn"
              id="lijikaitong"
              data-agl-cvt="7"
              @click="onSubscribe(item)"
            >立即开通</span>
          </template>
        </template>
        <template v-else-if="isHintValue(item, row)">
          <span class="cell-text cell-with-help">
            {{ cellMain(item, row) }}
            <el-tooltip
              :content="cellHint(item, row)"
              placement="top"
              effect="dark"
              popper-class="pkg-help-tooltip"
            >
              <i class="el-icon-question help-icon" @click.stop></i>
            </el-tooltip>
          </span>
        </template>
        <template v-else-if="isMultiValue(item, row)">
          <div
            v-for="(line, lineIdx) in cellValue(item, row)"
            :key="`aishort-line-${row.rowKey}-${lineIdx}`"
            class="cell-line"
            :class="{ 'is-emphasis': row.key === 'series' && lineIdx === 0 }"
          >{{ line }}</div>
        </template>
        <span v-else class="cell-text" :class="[markClass(cellValue(item, row)), { 'is-emphasis': row.key === 'download' }]">{{ cellValue(item, row) }}</span>
      </div>
    </template>
    <div class="table-note" :style="{ gridColumn: `1 / ${saleList.length + 3}` }">注：短剧订阅会员可下载全站音频素材，并在相应会员授权范围内使用，会员产品购买成功后不支持退换和转让，其中图片素材不可用于原创认证及线下渠道。</div>
  </div>
</template>

<script>
export default {
  name: 'AishortPackageTable',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      hoverId: null,
      // 2026-09-15 原示意行保留，便于回滚
      // featureRows: [
      //   { label: '授权', cell: '文字文字' },
      //   { label: 'VIP音乐授权', cell: '文字文字' },
      //   { label: 'VIP音乐', cell: '文字文字' },
      //   { label: 'VIP音乐授权', cell: '文字文字' },
      //   { label: '音乐授权', cell: '文字文字' }
      // ],
      featureGroups: [
        {
          name: '会员权益',
          rows: [
            { key: 'price', label: '会员价格', isPrice: true },
            {
              key: 'download',
              label: '下载次数',
              values: {
                ai1: '不限',
                aiUnlimited: '不限',
                real1: '不限',
                real2: '不限',
                custom: '不限'
              }
            },
            {
              key: 'series',
              label: '整部授权',
              desc: '单集时长<15分钟',
              values: {
                ai1: ['1部', '不限集数'],
                aiUnlimited: ['不限部', '不限集数'],
                real1: ['1部', '不限集数'],
                real2: ['2部', '不限集数'],
                custom: ['可定制', '不限集数']
              }
            },
            {
              key: 'allSite',
              label: '畅享全站音频素材',
              desc: '购买会员后，全站音频素材可下载和使用，无需额外付费',
              values: { ai1: '✓', aiUnlimited: '✓', real1: '✓', real2: '✓', custom: '✓' }
            },
            {
              key: 'audience',
              label: '受众数量&视频曝光&企业规模',
              values: {
                ai1: '无限制',
                aiUnlimited: '无限制',
                real1: '无限制',
                real2: '无限制',
                custom: '无限制'
              }
            },
            {
              key: 'platform',
              label: '发布平台（中国）',
              values: {
                ai1: '无限制',
                aiUnlimited: '无限制',
                real1: '无限制',
                real2: '无限制',
                custom: '海外可定制'
              }
            },
            {
              key: 'devices',
              label: '多设备登陆',
              values: { ai1: '✓', aiUnlimited: '✓', real1: '✓', real2: '✓', custom: '✓' }
            },
            {
              key: 'invoice',
              label: '企业发票',
              values: { ai1: '✓', aiUnlimited: '✓', real1: '✓', real2: '✓', custom: '✓' }
            },
            {
              key: 'select',
              label: '免费选曲',
              values: {
                ai1: '人工&AI 选曲',
                aiUnlimited: '人工&AI 选曲',
                real1: '人工&AI 选曲',
                real2: '人工&AI 选曲',
                custom: '人工&AI 选曲'
              }
            }
          ]
        },
        {
          name: '版权保障',
          rows: [
            {
              key: 'term',
              label: '授权期限',
              values: {
                ai1: { text: '随片永久', desc: '订阅服务期内已激活授权的项目作品可在已发表渠道永久保留' },
                aiUnlimited: { text: '随片永久', desc: '订阅服务期内已激活授权的项目作品可在已发表渠道永久保留' },
                real1: { text: '随片永久', desc: '订阅服务期内已激活授权的项目作品可在已发表渠道永久保留' },
                real2: { text: '随片永久', desc: '订阅服务期内已激活授权的项目作品可在已发表渠道永久保留' },
                custom: { text: '随片永久', desc: '订阅服务期内已激活授权的项目作品可在已发表渠道永久保留' }
              }
            },
            {
              key: 'area',
              label: '授权地域',
              values: {
                ai1: '中国',
                aiUnlimited: '中国',
                real1: '中国',
                real2: '中国',
                custom: '海外可定制'
              }
            },
            {
              key: 'certificate',
              label: '正版授权书',
              desc: '每个项目作品可在订阅服务期内独立开具授权书',
              values: { ai1: '✓', aiUnlimited: '✓', real1: '✓', real2: '✓', custom: '✓' }
            },
            {
              key: 'agreement',
              label: '授权协议',
              values: { ai1: '✓', aiUnlimited: '✓', real1: '✓', real2: '✓', custom: '✓' }
            }
          ]
        },
        {
          name: '特殊授权',
          rows: [
            {
              key: 'film',
              label: '制作成电影、电视剧、综艺以及 NFT 进行使用',
              values: { ai1: '×', aiUnlimited: '×', real1: '×', real2: '×', custom: '×' }
            },
            {
              key: 'sublicense',
              label: '进行转授权、原创认证；用于商标、logo 或实体印刷',
              values: { ai1: '×', aiUnlimited: '×', real1: '×', real2: '×', custom: '×' }
            },
            {
              key: 'sensitive',
              label: '肖像权敏感授权：医疗、药物、保健品、养生、美容、整形、交友等行业',
              values: { ai1: '×', aiUnlimited: '×', real1: '×', real2: '×', custom: '×' }
            }
          ]
        }
      ]
    }
  },
  computed: {
    saleList() {
      const list = (this.list || []).slice()
      const saleItems = []
      const customItems = []
      list.forEach((item) => {
        if (this.isCustomPackage(item)) customItems.push(item)
        else saleItems.push(item)
      })
      if (!customItems.length) {
        customItems.push({
          goods_id: 'aishort-custom-placeholder',
          name: '定制会员',
          price: 9999
        })
      }
      return saleItems.concat(customItems)
    },
    flatRows() {
      const rows = []
      this.featureGroups.forEach((group) => {
        const bodyRows = group.rows.filter((row) => !row.isPrice)
        group.rows.forEach((row) => {
          if (row.isPrice) {
            rows.push({
              ...row,
              groupName: group.name,
              showGutter: false,
              spanPriceLabel: true,
              groupSpan: 1,
              rowKey: `${group.name}-${row.key}`
            })
            return
          }
          const bodyIdx = bodyRows.indexOf(row)
          rows.push({
            ...row,
            groupName: group.name,
            showGutter: bodyIdx === 0,
            groupSpan: bodyRows.length,
            rowKey: `${group.name}-${row.key}`
          })
        })
      })
      return rows
    },
    tableStyle() {
      const count = this.saleList.length || 1
      return {
        gridTemplateColumns: `40px minmax(180px, 220px) repeat(${count}, minmax(0, 1fr))`
      }
    },
    defaultHighlightId() {
      const firstSale = this.saleList.find((item) => !this.isCustomPackage(item))
      return firstSale ? firstSale.goods_id : null
    },
    activeHighlightId() {
      return this.hoverId != null ? this.hoverId : this.defaultHighlightId
    }
  },
  methods: {
    isCustomPackage(item) {
      if (!item) return false
      if (item.name === '定制会员' || item.name === '短剧定制会员') return true
      const price = item.is_sum == 3 ? Number(item.per_price) : Number(item.price)
      return price == 9999
    },
    isAiPackage(item) {
      const name = item.name || ''
      return name.indexOf('AI') > -1 || name.indexOf('漫剧') > -1
    },
    packageKind(item) {
      if (this.isCustomPackage(item)) return 'custom'
      const cert = Number(item.cert_num)
      const price = Number(item.price)
      const isAi = this.isAiPackage(item)
      if (isAi) {
        if (cert == 9999 || price >= 2000) return 'aiUnlimited'
        return 'ai1'
      }
      if (cert == 2 || (price >= 2000 && !isAi)) return 'real2'
      if (cert == 1 || price <= 1600) return 'real1'
      return 'real2'
    },
    cellValue(item, row) {
      const kind = this.packageKind(item)
      if (!row.values) return ''
      if (row.values[kind] != null) return row.values[kind]
      return row.values.ai1 != null ? row.values.ai1 : ''
    },
    isMultiValue(item, row) {
      return Array.isArray(this.cellValue(item, row))
    },
    isHintValue(item, row) {
      const value = this.cellValue(item, row)
      return value && typeof value === 'object' && !Array.isArray(value) && value.text
    },
    cellMain(item, row) {
      return this.cellValue(item, row).text
    },
    cellHint(item, row) {
      return this.cellValue(item, row).desc
    },
    markClass(value) {
      if (value === '✓') return 'mark-yes'
      if (value === '×') return 'mark-no'
      return ''
    },
    isLeftLabelGroup(row) {
      return row.groupName === '特殊授权'
    },
    setHover(item) {
      this.hoverId = item.goods_id
    },
    clearHover() {
      this.hoverId = null
    },
    isHighlight(item) {
      return item && item.goods_id === this.activeHighlightId
    },
    displayPrice(item) {
      if (item.is_sum == 3) return Number(item.per_price)
      return Number(item.price)
    },
    // 2026-10-23：按套餐类型和价格追加单位
    priceUnit(item) {
      const price = Number(this.displayPrice(item))
      if (this.isAiPackage(item)) {
        if (price === 699) return '/部'
        if (price === 2199) return '/多部'
        return ''
      }
      if (price === 1499) return '/部'
      if (price === 2199) return '/2部'
      return ''
    },
    onSubscribe(item) {
      const payType = (item.is_month == 1 || item.is_sum == 3) ? 'month' : 'pay'
      this.$emit('subscribe', item, payType)
    }
  }
}
</script>

<style lang="scss" scoped>
.compare-table {
  display: grid;
  width: 100%;
  background: transparent;
  overflow: visible;
  padding-top: 10px;
  box-sizing: border-box;
}
.head {
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  background: linear-gradient(180deg, #ffe4c8 0%, #ffd3aa 100%);
  color: #b85c2a;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  line-height: 1.2;
  transition: background 0.15s ease;
  box-sizing: border-box;
  position: sticky;
  top: 60px;
  z-index: 9;
}
.label-head {
  grid-column: 1 / 3;
  border-radius: 16px 0 0 0;
  border-left: 1px solid #e8ddd3;
  border-right: 1px solid #e8ddd3;
}
.pkg-head {
  cursor: pointer;
  border-right: 1px solid #e8ddd3;
  &.is-last:not(.highlight) {
    border-radius: 0 16px 0 0;
  }
  &.highlight {
    border-radius: 0;
    background: linear-gradient(180deg, #ffd7b0 0%, #ffc091 100%);
    box-shadow: 0 6px 12px rgba(255, 156, 92, 0.18);
    z-index: 10;
    &::before {
      content: '';
      position: absolute;
      top: -8px;
      left: 0;
      right: 0;
      height: 8px;
      background: #ffd7b0;
      border-radius: 16px 16px 0 0;
      box-sizing: border-box;
    }
    &.is-last::before {
      border-right: 1px solid #e8ddd3;
    }
  }
}
.gutter {
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: vertical-rl;
  letter-spacing: 2px;
  font-size: 19px;
  color: #fc4243;
  font-weight: 700;
  border-left: 1px solid #e8ddd3;
  border-right: 1px solid #e8ddd3;
  border-top: 1px solid #e8ddd3;
  background: #fff;
  box-sizing: border-box;
}
.feat-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #e8ddd3;
  border-right: 1px solid #e8ddd3;
  color: #666;
  font-size: 13px;
  box-sizing: border-box;
  background: #fff;
  padding: 20px 12px;
  min-height: 56px;
  text-align: center;
  line-height: 1.5;
  &.highlight {
    background: linear-gradient(180deg, #fff6ee 0%, #fffdf9 100%);
    position: relative;
    z-index: 1;
  }
}
.label-cell {
  flex-direction: column;
  color: #333;
  &.is-left {
    align-items: flex-start;
    text-align: left;
    .label-text,
    .label-desc {
      text-align: left;
    }
    .label-text {
      align-items: flex-start;
    }
  }
}
.pkg-cell {
  cursor: pointer;
  flex-direction: column;
}
.feat-cell.price-cell {
  min-height: 148px;
  height: auto;
  position: sticky;
  top: 114px;
  z-index: 8;
}
.price-label {
  border-left: 1px solid #e8ddd3;
}
.label-text {
  color: #333;
  font-size: 14px;
  text-align: center;
  display: inline-flex;
  align-items: center;
}
.label-desc {
  margin-top: 4px;
  color: #999;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;
}
.cell-text.is-emphasis,
.cell-line.is-emphasis {
  color: #fc4243;
  font-weight: 700;
}
.cell-line + .cell-line {
  margin-top: 4px;
  font-size: 12px;
  color: #999;
}
.cell-text {
  white-space: pre-wrap;
  &.mark-yes {
    color: #22c55e;
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
  }
  &.mark-no {
    color: #fc4243;
    font-size: 20px;
    font-weight: 700;
    line-height: 1;
  }
}
.table-note {
  grid-column: 1 / -1;
  padding: 16px 24px;
  font-size: 13px;
  color: #666;
  line-height: 1.7;
  text-align: left;
  background: #fff;
  border-top: 1px solid #e8ddd3;
  border-left: 1px solid #e8ddd3;
  border-right: 1px solid #e8ddd3;
  border-bottom: 1px solid #e8ddd3;
  border-radius: 0 0 16px 16px;
  box-sizing: border-box;
}
.current-price {
  color: #fc4243;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 12px;
  font-family: alipuhuir, PingFang SC, sans-serif;
  &.is-contact {
    font-size: 26px;
  }
  i {
    font-style: normal;
    font-size: 16px;
    margin-right: 2px;
  }
  span {
    font-size: 14px;
    font-weight: 500;
    margin-left: 2px;
  }
}
.cta-btn {
  display: inline-block;
  min-width: 80px;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  border-radius: 16px;
  background: linear-gradient(135deg, #fe7273 0%, #fc4243 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  text-align: center;
  cursor: pointer;
  user-select: none;
}
.cell-with-help {
  display: inline-flex;
  align-items: center;
}
.help-icon {
  margin-left: 4px;
  color: #b0b0b0;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
  line-height: 1;
}
</style>
<style lang="scss">
.pkg-help-tooltip {
  max-width: 320px;
  line-height: 1.6;
}
</style>
